import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-daily-booking-graph',
  templateUrl: './daily-booking-graph.component.html',
  styleUrls: ['./daily-booking-graph.component.scss']
})
export class DailyBookingGraphComponent implements OnInit {
  loader: boolean = false
  _apisub: Subscription

  bookingsData: any[] = []
  bookingsGraphData: any
  constructor(private _apiservice: ApiService) {

    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_COMPOSITE_BOOKING_DATA_FOR_DASHBOARD){
        this.bookingsData = []
        if(resdata.result){
          this.bookingsData = resdata.result
          //assign to graph
   
          //   this.bookingsGraphData = {
          //     datasets: [{
          //         label: 'Shop Bookings',
          //         data: this.bookingsData.map(item => {
          //           return item.shop_bookings
          //       }),
          //         // backgroundColor: "rgb(115 185 243 / 65%)",
          //         borderColor: "#ff0000",
          //         fill: false,
          //         lineTension: 0
          //     },
          //     {
          //       label: 'Home Bookings',
          //       data: this.bookingsData.map(item => {
          //         return item.home_bookings
          //     }),
          //       // backgroundColor: "#47a0e8",
          //       borderColor: "#007ee7",
          //       fill: false,
          //       lineTension: 0
        
          //     },
          //     {
          //       label: 'Cancelled Bookings',
          //       data: this.bookingsData.map(item => {
          //         return item.cancelled_bookings
          //     }),
          //       // backgroundColor: "#47a0e8",
          //       borderColor: "#ffc107",
          //       fill: false,
          //       lineTension: 0
        
          //     },
          //   ],
        
          //     labels: this.bookingsData.map(item => {
          //       return new Date(item.date).toLocaleDateString()
          //   })
        
          // }

          // NEW WAY

          // Flatten the sales data and group by business
          const uniqueBusinesses = new Map<string, string>();

          this.bookingsData.forEach(dataItem => {
              const salesArray = JSON.parse(dataItem.sales);
              salesArray.forEach((sale:any) => {
                  uniqueBusinesses.set(sale.entity_hash, sale.entity_name);
              });
          });

          // Get all unique dates for the x-axis
          const allDates = [...new Set(this.bookingsData.map(dataItem => new Date(dataItem.date).toLocaleDateString()))].sort();

          // Prepare datasets for the graph
          const datasets = Array.from(uniqueBusinesses.entries()).map(([entityHash, entityName], index) => {
              return {
                  label: entityName,
                  data: allDates.map(date => {
                      // Find bookings data for this business on the current date
                      const matchingData = this.bookingsData.find(dataItem => {
                          return new Date(dataItem.date).toLocaleDateString() === date;
                      });

                      if (matchingData) {
                          const salesArray = JSON.parse(matchingData.sales);
                          const businessBookings = salesArray.find((sale:any) => sale.entity_hash === entityHash);
                          if (businessBookings) {
                              return businessBookings.total_bookings; // Change to shop_bookings, home_bookings, etc., if needed
                          }
                      }
                      return 0; // Default to 0 if no data found for this business on this date
                  }),
                  borderColor: this.getDistinctColor(index, uniqueBusinesses.size), // Use distinct colors for each business
                  fill: false,
                  lineTension: 0
              };
          });

          // Assign the data to the graph
          this.bookingsGraphData = {
              datasets,
              labels: this.formatDateToReadable(allDates)
          };


        }
        console.log(this.bookingsData);
        console.log(this.bookingsGraphData);
        this.loader = false
        // this.loaderservice.showLoader = false
      }
    })

   }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getCompositeBookingDataForDashboard()
  }


  getDistinctColor(index: number, total: number): string {
    const hue = (index / total) * 360; // Spread hues evenly across 360 degrees
    return `hsl(${hue}, 70%, 50%)`; // Vibrant and distinguishable colors
}

formatDates(dateArray:any) {
  return dateArray.map((dateString:any) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
      return `${day} ${month}`;
  });
}

formatDateToReadable(dateArray: any[]): string[] {
  console.log("dates", dateArray);

  return dateArray.map((dateString: string) => {
    // Parse DD/MM/YYYY format manually
    const [day, month, year] = dateString.split('/').map(Number);

    // Create a valid Date object (month is zero-based in JavaScript)
    const parsedDate = new Date(year, month - 1, day);

    // Check if the parsedDate is valid
    if (isNaN(parsedDate.getTime())) {
      console.error(`Invalid date format: ${dateString}`);
      return "Invalid Date"; // Or handle the error as needed
    }

    // Format the valid date as 'dd MMM'
    return formatDate(parsedDate, 'dd MMM', 'en-US');
  });
}

// formatDates(dateArray: any) {
//   return dateArray.map((dateString: any) => {
//     const [year, month, day] = dateString.split('-'); // Ensure the format is YYYY-MM-DD
//     if (!year || !month || !day) {
//       console.error(`Invalid date format: ${dateString}`);
//       return 'Invalid Date';
//     }
//     const date = new Date(Number(year), Number(month) - 1, Number(day));
//     const dayNum = date.getDate();
//     const monthName = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
//     return `${dayNum} ${monthName}`;
//   });
// }

}
